export default "data:image/webp;base64,UklGRkAAAABXRUJQVlA4IDQAAADQAQCdASoQAAQAAsBMJZQCdAD0gdm5QAD+8BcaIt0tkjbF973ZngQyWU+zTDsIVNsnDbAA";